import { Navigate, Route, Routes } from 'react-router-dom';
import type { ReactElement } from 'react';
import { useAuth } from '@/auth/useAuth';
import { AppLayout } from '@/components/layout/AppLayout';
import LoginPage from '@/pages/LoginPage';
import ConfigurationsPage from '@/pages/ConfigurationsPage';
import ApartmentsPage from '@/pages/ApartmentsPage';
import ConfiguratorPage from '@/pages/ConfiguratorPage';
import ConfigurationResumePage from '@/pages/ConfigurationResumePage';
import BoxConfigurationsPage from '@/pages/BoxConfigurationsPage';
import BoxConfiguratorPage from '@/pages/BoxConfiguratorPage';
import BoxResumePage from '@/pages/BoxResumePage';

function ProtectedRoute({ children }: { children: ReactElement }): ReactElement {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/configurations"
        element={
          <ProtectedRoute>
            <AppLayout>
              <ConfigurationsPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/apartments"
        element={
          <ProtectedRoute>
            <AppLayout>
              <ApartmentsPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/configurations/:id"
        element={
          <ProtectedRoute>
            <AppLayout>
              <ConfiguratorPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/configurations/:id/resume"
        element={
          <ProtectedRoute>
            <AppLayout>
              <ConfigurationResumePage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/box"
        element={
          <ProtectedRoute>
            <AppLayout>
              <BoxConfigurationsPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/box/:id"
        element={
          <ProtectedRoute>
            <AppLayout>
              <BoxConfiguratorPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/box/:id/resume"
        element={
          <ProtectedRoute>
            <AppLayout>
              <BoxResumePage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/apartments" replace />} />
      <Route path="*" element={<Navigate to="/apartments" replace />} />
    </Routes>
  );
}
